import FilterColumnsDropdown from 'utils/components/FiltersModal/FilterColumnsDropdown';
import {
    symbolInfoColumnDefinitionDictionary,
    SymbolInfoColumns,
} from 'symbols/symbolInfo/columns';
import React from 'react';
import { SymbolInfo } from 'symbols/symbolInfo/symbolInfoSlice';

const visibleColumns: Array<keyof SymbolInfo> = [
    'iSymbol',
    'bloomSymbol',
    'assetClass',
    'region',
    'country',
    'exchangeSymbol',
    'currencyCode',
    'description',
    'isin',
    'industry',
    'sector',
    'subIndustry',
    'superSector',
    'securityType',
];

export function SymbolInfoAttributeDropdown(props: {
    currentValue?: SymbolInfoColumns;
    onChanged: (nextValue: SymbolInfoColumns) => void;
}) {
    const { currentValue, onChanged } = props;

    return (
        <FilterColumnsDropdown
            className="SymbolInfoAttributeDropdown"
            columnDefinitions={symbolInfoColumnDefinitionDictionary}
            visibleColumns={visibleColumns}
            editingColumn={currentValue}
            setEditingColumn={onChanged}
        />
    );
}
